import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {DungeonQuestLayerConfig} from "../config/DungeonQuestLayerConfig";
import {ShakeConfig, ShakeEffect} from "../game/display/effects/ShakeEffect";
import {DungeonQuest} from "../game/DungeonQuest";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";

/**
 * Class description
 *
 * Created: 2018-05-31
 * @author jonas
 */
export class ShakeUtil {

    public static createDefaultShake(stepMaxDistance:number = 4, stepDuration:number = 0.03):ShakeEffect {
        let shakeObjects:PIXI.DisplayObject[] = [
            DungeonQuest.reelAreaEffectController.reelAreaBackgroundView,
            DungeonQuest.logoAreaView.shakeObject,
            Reels.getReel(0)!.view,
            Reels.getReel(1)!.view,
            Reels.getReel(2)!.view,
            Reels.getReel(3)!.view,
            Reels.getReel(4)!.view
        ];

        shakeObjects = shakeObjects.concat(StageManager.getLayer(DungeonQuestLayerConfig.BACKGROUND.name).children);

        return new ShakeEffect(shakeObjects, new ShakeConfig(stepMaxDistance, stepDuration));
    }
}